export default "__VITE_ASSET__BOnHzmon__"